module.exports = __webpack_public_path__ + "img/SysComm4.a14cf0d2.png";